import { Heading, Prose, Section } from "@ffn/components"
import { createFileRoute, Link } from "@tanstack/react-router"
import { latestEssays } from "../content/field-notes.js"
import { EssayList } from "../features/NoteList.js"
import { SelectedWork } from "../features/SelectedWork.js"
import { GemHero } from "../hero/GemHero.js"
import { homeHead } from "../seo/index.js"
import "../content.css"
import "../notes.css"

export const Route = createFileRoute("/")({ head: homeHead, component: HomePage })

function HomePage() {
  return (
    <>
      <GemHero />
      <Section className="SiteSection" aria-labelledby="frontier-field-notes">
        <header className="SiteSectionHead">
          <Heading id="frontier-field-notes" level={2}>
            Frontier Field Notes
          </Heading>
        </header>
        <EssayList notes={latestEssays(3)} />
        <Prose>
          <p className="SiteNotesMore">
            <Link to="/notes">All Frontier Field Notes</Link>
          </p>
        </Prose>
      </Section>
      <Section className="SiteSection" aria-labelledby="selected-work">
        <header className="SiteSectionHead">
          <Heading id="selected-work" level={2}>
            Selected work
          </Heading>
          <p>Tools for checking, running, understanding, and remembering agent work.</p>
        </header>
        <SelectedWork />
      </Section>
      <Section className="SiteSection SiteHomeAbout" aria-labelledby="home-about">
        <Heading id="home-about" level={2}>
          Beyond the work
        </Heading>
        <Prose>
          <p>
            Houston by way of Riverside, California. Science labs before software. Outside work:
            fishing, paintball, fiction, and a home gym run by a Raspberry Pi.
          </p>
          <p>
            <Link to="/about">More about me</Link>
          </p>
        </Prose>
      </Section>
    </>
  )
}
